<template>
  <!--用户注册-->
  <div class="register">
    <div class="header" style="font-size: 16px;">
      <img src="./zhuce.png" alt="">新用户注册
    </div>
    <ul class="reg-box">
      <li class="errmsg">
        {{msg}}
      </li>
      <li>
        <label >
          <span style="font-size: 16px;">姓名</span>
          <input type="text" style="font-size: 16px;" v-model="userData.name" placeholder="姓名">
        </label>
      </li>
      <li>
        <label>
          <span style="font-size: 16px;">手机号</span>
          <input type="text" style="font-size: 16px;" v-model="userData.phone" placeholder="手机号">
        </label>
      </li>
      <li>
        <label>
          <span style="font-size: 16px;">邮箱</span>
          <input type="text" style="font-size: 16px;" v-model="userData.email" placeholder="邮箱">
        </label>
      </li>
      <li>
        <label>
          <span style="font-size: 16px;" >密码</span>
          <input type="password" style="font-size: 16px;" v-model="userData.pwd" placeholder="密码">
        </label>
      </li>
      <li class="login">
        <p @click="doSign" style="font-size: 16px;">登录</p>
      </li>
    </ul>
    <div class="reg-btn-box">
      <button @click="doReg" style="font-size: 16px;">确认</button>
    </div>
  </div>
</template>
<script>
  /*
   * /api/register/add
   * firstpy   lastpy   email  pwd language
   * */
  import bus from '../../bus'
  import md5 from 'md5';
  export default{
    data(){
      return {
        showErrorMsg: false,
        showMsg: false,
        msg: '',
        userData: {
          name: '',
          phone: '',
          email: '',
          pwd: '',
          language: 'cn'
        }
      }
    },
    props: {},
    methods: {
      //去往注册页面
      doSign(){
        this.$router.push('/home/2006/detail/login_cn');
      },
      doReg(){
        console.log(1);
        let userData = this.userData;
        if (this.userData.name.length === 0) {
          this.msg = '请输入您的姓名';
          this.showMsg = true;
          return;
        } else if (this.userData.phone.trim().length === 0) {
          this.msg = '请输入您的手机号';
          this.showMsg = true;
          return;
        }else if(this.userData.phone.trim().length != 0){
          var phone = /^1[34578]\d{9}$/;
          if(!phone.test(this.userData.phone.trim())){
            this.msg = '请输入正确的手机号！';
            this.showMsg = true;
            return;
          }
        }else {
          this.showMsg = false;
        }

        if (this.userData.email.trim().length === 0) {
          this.msg = '请输入您的邮箱';
          this.showMsg = true;
          return;
        } else if(this.userData.email.trim().length != 0){
          let myreg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;


          if(!myreg.test(this.userData.email.trim())){
            this.msg = '请输入正确的邮箱格式！';
            this.showMsg = true;
            return;
          }
        }else {
          this.showMsg = false;
        }
        if (this.userData.pwd.trim().length === 0) {
          this.msg = '请输入您的密码';
          this.showMsg = true;
          return;
        } else {
          this.showMsg = false;
        }
        axios.post('/medapp/api/register/add', {
          name: userData.name,
          phone: userData.phone,
          email: userData.email,
          pwd: md5(userData.pwd),
          vpwd:userData.pwd,
          cid:2006,
          language: 'ch'
        })
          .then((result) => {
            console.log(result.data);
            let data = result.data;
//            用户注册成功
            if (data.code === '0') {
              let cid = this.$route.params.cid;
//            保存登录令牌；
              localStorage.setItem('token', data.token.tToken);
              localStorage.setItem('user', JSON.stringify(data.user));
              localStorage.setItem('locale', 'ch');
              bus.$emit('exitActive', true);
              this.$router.push('/home/2006');
            } else if(data.code === '1006'){
              this.msg = '邮箱已经存在请登录!';
              this.showMsg = true;
            }else if(data.code === '1001'){
              this.msg = '手机号已经注册！';
              this.showMsg = true;
            }
          })
      }
    },
    computed: {},
    mounted(){
        // alert(1)
    }
  }
</script>
<style scoped>
  .login{
    text-align: right;
  }
  .login p{
    display: inline-block;
    cursor: pointer;
  }
  .register {
    font-family: "Arial";
  }

  .reg-box .errmsg {
    color: red;
    font-size: 14px;
    margin-left: 147px;
  }

  .header {
    height: 89px;
    background-color: #F4F4F7;
    color: #4C4E82;
    font-size: 22px;
    line-height: 89px;
  }

  .header img {
    vertical-align: middle;
    margin-left: 50px;
    margin-right: 21px;
  }

  /*注册框开始*/
  .reg-box {
    width: 815px;
    margin: 48px auto 0;
    font-size: 20px;
  }

  .reg-box li {
    margin: 20px 0;
  }

  .reg-box label span {
    display: inline-block;
    width: 120px;
    text-align: right;
    line-height: 40px;
    color: #000;
    margin-right: 20px;
  }

  .reg-box label input {
    width: 665px;
    height: 40px;
    background-color: #f3f3f6;
    border: 1px solid #141651;
    padding-left: 18px;
    box-sizing: border-box;
    font-size: 20px;
  }

  .reg-btn-box {
    text-align: center;
    margin-top: 84px;
  }

  .reg-btn-box button {
    color: #FFFFFF;
    /*font-size: 22px;*/
    border: 0;
    background-color: #141651;
    padding: 12px 63px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// register_cn.vue?59708702